/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import DndSlotItemHandler from './DndSlotItemHandler';

/**
 * Inherits from DndSlotItemHandler and overrides methods
 */
class DndSlotFilterItemHandler extends DndSlotItemHandler {
	constructor(options) {
		super(options);
		this.filterEditorNode = options.filterEditorNode;
	}

	_setupDnD() {
		this.dndManager.registerDropTarget({
			el: this.domNode,
			type: 'slot.filter',
			info: (domNode, event) => ({
				dragInfo: {
					position: {
						x: event.clientX,
						y: event.clientY
					}
				},
				node: domNode,
				filterEditorNode: this.filterEditorNode,
				slotDataItemHandler: this.slotDataItemHandler,
				contentId: this.slotDataItemHandler.getContentId(),
				isVisOverlay: this.isVisOverlay,
				onDragEnter: this.activateDropTarget.bind(this),
				onDragLeave: this.deactivateDropTarget.bind(this)
			})
		});
	}
}

export default DndSlotFilterItemHandler;



// WEBPACK FOOTER //
// ./src/js/DndSlotFilterItemHandler.js